import { INPAGE_ERROR_CHARTS, FIT_ILLUSTRATOR_ERROR_CHARTS, SMART_TABLE_ERROR_CHARTS } from "@/misc/filterErrorCharts";

export default (targetChartInfo, selectedFilters, showOnlyUniqueUsers) => {
  const activeProductsFilterName = selectedFilters?.products?.[0]?.name;
  if (!activeProductsFilterName) return false;

  let errorChartNames;
  switch (activeProductsFilterName) {
    case "inpage":
      errorChartNames = INPAGE_ERROR_CHARTS;
      break;
    case "fitIllustrator":
      errorChartNames = FIT_ILLUSTRATOR_ERROR_CHARTS;
      break;
    case "smartTable":
      errorChartNames = SMART_TABLE_ERROR_CHARTS;
      break;
    default:
      break;
  }
  if (!errorChartNames) return false;

  errorChartNames = showOnlyUniqueUsers ? errorChartNames.map((name) => `unique-${name}`) : errorChartNames;
  return (
    errorChartNames.includes(targetChartInfo.rateChartName) || errorChartNames.includes(targetChartInfo.valueChartName)
  );
};
